import getActivePage from 'src/helpers/active-page-details';
import sanitizeContent from 'src/utils/sanitize-content';
import DesygnerApi from '../editor/factory/desygner-api';
import { memoize } from 'src/utils/toolbelt';

export const createSvgElement = memoize(svgString => {
  const parser = new DOMParser();
  const svgElement = parser.parseFromString(svgString, 'text/html').body.firstElementChild;

  if (!svgElement?.querySelector('svg')) {
    // There must be a wrapping svg so overflow is hidden
    const wrapperSvg = svgElement.cloneNode();
    wrapperSvg.appendChild(svgElement);

    return wrapperSvg;
  }

  return svgElement;
});

// TODO: Write unit tests
export async function getPageContentStringByIds (pageIds) {
  const activePage = getActivePage();
  const isActivePage = (id) => String(id) === activePage.id;
  const pages = await Promise.all(pageIds.map((pageId) => {
    if (isActivePage(pageId)) {
      return Promise.resolve({ id: pageId, content: activePage.content });
    }
    return INKIVE.PageFactory.getPage(Number(pageId));
  }));

  return pages.reduce((obj, item) => {
    return {
      ...obj,
      [item.id]: sanitizeContent(item.content)
    };
  }, {});
}

export async function getPageContentStringByIdsBatch (pageIds) {
  const resourceId = INKIVE.C.BOOK.encodedId;
  const urls = [];
  const pages = {};

  for (const pageId of pageIds) {
    if (String(pageId) === String(INKIVE.PageFactory.getCurrentPageId())) {
      pages[pageId] = INKIVE.Tool._current_page_content;
      continue;
    }
    urls.push(`business/projects/${resourceId}/pages/${pageId}`);
  }

  if (urls.length === 0) return pages;
  const responses = await DesygnerApi.processBatch(urls);
  for (const response of responses) {
    const page = response.body;
    const svgString = sanitizeContent(page.content);
    pages[page.id] = svgString;
  }

  return pages;
}

export async function getPageContentById (pageId) {
  const isActivePage = String(pageId) === String(INKIVE.PageFactory.getCurrentPageId());

  const string = isActivePage
    ? getActivePage().content
    : await fetchPageSvgString(pageId);

  return createSvgElement(string).cloneNode(true);
}

// TODO: Replace with api-gateway
async function fetchPageSvgString (pageId) {
  const resourceId = INKIVE.C.BOOK.encodedId;
  const credentials = CONFIG.credentials;
  const baseURL = INKIVE.C.API_URL;
  const url = `${baseURL}business/projects/${resourceId}/pages/${pageId}`;
  const headers = new window.Headers({
    Authorization: 'Basic ' + btoa(`${credentials.token}:${credentials.hash}`)
  });
  const response = await fetch(url, { method: 'get', headers });
  const page = await response.json();
  const svgString = sanitizeContent(page.content);

  return svgString;
}

export async function getPageContent (pageIndex) {
  const pageNumber = pageIndex + 1;
  const design = INKIVE.ProjectFacade.get('design', { page_number: pageNumber });

  if (!design || !design.design_id) throw new Error('Page not found');

  const project = await INKIVE.DesygnerApi.get(`business/projects/${INKIVE.C.BOOK.id}/pages/${design.design_id}`);

  return {
    pageId: project.id,
    pageContent: parseToElement(project.pageContent || project.content)
  };
}

const XML_PREFIX = '<?xml version="1.0"?>';

export function removeXMLComment (str) {
  return str.startsWith(XML_PREFIX)
    ? str.substring(XML_PREFIX.length)
    : str;
}

function parseToElement (svgString) {
  const parser = document.createElement('div');
  parser.innerHTML = sanitizeContent(removeXMLComment(svgString));
  return parser.firstChild;
}
